import './assets/main.css'
import './assets/styles/buttons.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { createI18n } from 'vue-i18n'

const i18n = createI18n({
  locale: 'es', // Idioma predeterminado
  fallbackLocale: 'es', // Idioma de respaldo si no se encuentra una clave
  messages: {
    en: {
      footer: {
        moreInfo: 'MORE INFORMATION',
        infoDescription:'Tell us your digital solution ideas for businesses and industries, and we’ll help you make them a reality.',
        findUs: 'Find us at: Cra. 49c #75 - 47',
        contact: 'CONTACT',
        followUs: 'FOLLOW US',
      },
      navbar: {
        home: 'Home',
        services: 'Services',
        products: 'Products',
        aboutUs: 'About us',
        ourWork: 'Our work',
        contactUs: 'Contact us',
      },
      services: {
        softwareDevelopment: 'Software Development',
        softwareDevelopmentDesc:'We craft scalable, efficient, and innovative software solutions tailored to your business needs. From custom applications to system integrations, our team ensures seamless functionality and robust performance to elevate your operations.',
        userExperience: 'User Experience (UX)',
        userExperienceDesc:'Deliver exceptional digital experiences with our user experience services. We design intuitive interfaces and seamless interactions that prioritize your users, ensuring satisfaction and driving engagement.',
        powerfulAI: 'Powerful AI',
        powerfulAIDesc:'Unlock the full potential of artificial intelligence with our cutting-edge solutions. From predictive analytics to automation, we harness AI to deliver smarter, faster, and more impactful outcomes for your business.',
        productDesign: 'Product Design',
        productDesignDesc:'Transform your ideas into reality with our product design services. We blend creativity and technical expertise to develop user-centric solutions that are functional, visually appealing, and perfectly aligned with your business goals.',
        hardwareIntegrator:'Hardware Integrator',
        hardwareIntegratorDesc:'Seamlessly connect and optimize your systems with our hardware integration services. We specialize in integrating advanced devices and technologies to create unified systems that improve productivity and operational efficiency.',
        itConsulting: 'IT Consulting',
        itConsultingDesc:'Empower your business with strategic IT consulting that drives digital transformation. We provide expert guidance to align your technology investments with your objectives, enhancing your infrastructure and achieving long-term success.',
      },

      pricing: {
        plans: {
          basic: {
            title:'F-Basic',
            price:'24,900 COP',
            trial:'14 days free trial',
            button:'Choose this plan',
            includes:'F-Basic plan includes:',
            features: {
              moduleAccess: 'Access to 2 management modules.',
              adminPanel: 'Access to admin panel.',
              notifications: 'No notifications or maintenance.',
              reports: 'No reports or intelligent analytics.',
            },
          },
          pro: {
            title: 'F-Pro',
            price: '89,900 COP',
            trial: '30 days free trial',
            button: 'Choose this plan',
            includes: 'F-Pro plan includes:',
            features: {
              moduleAccess: 'Access to all management modules.',
              adminPanel: 'Access to admin panel.',
              notifications: 'Notifications and maintenance.',
              reports: 'Reports and intelligent analytics.',
            },
          },
          enterprise: {
            title: 'F-Enterprise',
            price: '200,900 COP',
            trial: '7 days free trial',
            button: 'Choose this plan',
            includes: 'F-Enterprise plan includes:',
            features: {
              moduleAccess: 'Access to all management modules.',
              adminPanel: 'Access to admin panel.',
              notifications: 'Notifications and maintenance.',
              reports: 'Reports and intelligent analytics.',
            },
          },
        },
      },
      pricingdescription:'Ftrack offers flexible plans to suit the needs of businesses of all sizes. From the basic plan for companies starting their asset monitoring journey, to advanced options with comprehensive features for larger organizations. Each plan includes a free trial, so you can experience all the benefits before making a decision. Find the perfect plan for you and optimize your asset management today.',
      usecasedescription:'Ftrack is a versatile asset monitoring platform, suitable for a wide range of industries. It enables companies across various sectors, from logistics to manufacturing, to manage and track their assets in real time, optimizing operations and reducing costs with smart alerts and a customizable interface.',
      title: 'What does ftrack offer?',
      realtime: 'Real-time',
      realtimeDescription:'Visualize all your assets on an interactive map and stay informed with real-time updates. Keep track of the location and status of your assets.',
      smartAlerts: 'Smart Alerts',
      smartAlertsDescription: 'Receive immediate predictive alerts for any eventuality.',
      whiteLabelPlatform: 'White Label Platform',
      whiteLabelDescription: 'Customize your experience with your own logos and colors.',
      assetManagement: 'Asset Management',
      assetManagementDescription:'Organize and categorize all your assets in one place for monitoring and control.',
      iotIntegrations: 'IoT Integrations',
      iotIntegrationsDescription: 'Connect smart devices for complete monitoring.',
      maintenanceManagement: 'Maintenance Management',
      maintenanceDescription: 'Store the maintenance history and documentation of your assets.',
      casesOfUse: 'Use Cases',
      pricingg: 'Pricing',
      basicPlan: 'F-Basic',
      basicPlanDescription: 'Includes 2 management modules, admin panel access.',
      proPlan: 'F-Pro',
      proPlanDescription: 'Includes all management modules, admin panel access, and predictive alerts.',
      enterprisePlan: 'F-Enterprise',
      enterprisePlanDescription:'Includes all management modules, admin panel access, predictive alerts, and smart analysis.',
      freeTrial: 'Free 14-day trial',
      freeTrialPro: 'Free 30-day trial',
      freeTrialEnterprise: 'Free 7-day trial',
      choosePlan: 'Choose this plan',
      requestDemo: 'Request your free demo',
      contact: {
        modal: {
          confirmation: {
            title: 'Are you sure you want to send the request?',
            message: 'Once you send the request, you won’t be able to edit the information.',
          },
          success: {
            title: 'Email sent successfully!',
            message: 'Thank you for contacting us. We will get in touch with you shortly.',
          },
        },
        header: {
          title: 'We’d love to help you',
          description:
            'Do you have questions, concerns, or an idea you’d like to share? Our team is here to listen and find solutions tailored to your needs.',
        },
        form: {
          firstName: {
            label: 'First name',
            placeholder: 'First Name',
          },
          lastName: {
            label: 'Last name',
            placeholder: 'Last Name',
          },
          companyName: {
            label: 'Company name (optional)',
            placeholder: 'Fourin SAS',
          },
          email: {
            label: 'Email',
            placeholder: 'email',
          },
          phone: {
            label: 'Phone number',
            placeholder: 'Enter your phone number',
          },
          message: {
            label: 'Message',
            placeholder: 'Leave us a message here...',
          },
          button: 'Send message',
        },
      },
      about: {
        title: 'About us',
        bigText: 'We are a team of professionals',
        description:'At FOURIN S.A.S, we are dedicated to empowering businesses through cutting-edge technology and tailored solutions. Based in Colombia, our team combines expertise in software development, product design, hardware integration, IT consulting, and artificial intelligence to deliver innovative and impactful results.',
      },
      stats: {
        projectsCompleted: {
          bigText: '5+',
          subtitle: 'Projects completed',
          description:'Projects full of experiences and knowledge shape us as a company at FOURIN S.A.S.',
        },
        satisfaction: {
          bigText: '96%',
          subtitle: 'Satisfaction',
          description:'Our clients satisfaction speaks to the constant quality that our company provides.',
        },
        recommendations: {
          bigText: '9/10',
          subtitle: 'Recommendations',
          description: 'Metrics show that online commercialization generates long-term benefits.',
        },
      },
      goals: {
        title: 'Our mission',
        description:'Is to transform ideas into reality by seamlessly integrating technology into your processes. We believe in simplifying complexity and optimizing operations, ensuring every solution is aligned with your unique goals and challenges.',
        description2:'With a strong focus on user experience and a passion for innovation, we help our clients unlock their full potential, whether it’s automating workflows, designing intuitive products, or implementing AI-driven strategies. Our approach is collaborative, customer-centric, and results-driven.',
        description3:'At FOURIN, we are not just solving problems – we are shaping the future of technology. Let’s build it together.',
      },
      approach: {
        title: 'Our approach',
        innovation: 'Innovation at the Core: We integrate the latest advancements in tech and AI.',
        customer: 'Customer-Centric Solutions: Your needs guide everything we do.',
        integration: 'Seamless Integration: From software to hardware, we create unified systems.',
        growth: 'Empowering Growth: Our solutions drive efficiency and success.',
      },
      know: {
        title:'Get to know us: a passionate team of innovators dedicated to overcoming challenges and making an impact.',
        become:'To become the company that customers want, it takes a group of passionate people.',
        knowtext:'At Fourin, we provide innovative and tailored solutions designed to meet your unique needs. We stand out with our attention to detail, exceptional support, and dedication to the success of your projects. Choose quality, expertise, and guaranteed results. We areyour best choice!',
        transform:'Ready to transform your business with technology? Contact us and lets make it happen!',
      },
      home: {
        banner: {
          title: 'Making Innovation Grow through Tech and AI',
          description:'Unleash the possibilities of the future with Fourin. Experience the full potential of technology through our tailored solutions designed to drive your business.',
          button: 'Contact us',
        },
        expertise: {
          title: 'Our expertise',
          subtitle: 'For all your tech needs.',
          button: 'More info',
        },
        projects: {
          title: 'Products',
          monitorTitle: 'Monitor your assets in real time',
          monitorDescription:'Ftrack is your ultimate partner in asset management, offering intelligent solutions that redefine how businesses track, monitor, and optimize their resources. With cutting-edge technology and a user-centric approach, Ftrack simplifies complex processes, provides actionable insights, and ensures that every asset delivers maximum value.',
          discoverButton: 'Discover',
        },
        sponsors: {
          title: 'They support us',
          description:'Enhance efficiency and streamline operations with our AI-driven solutions. Optimize your business processes to achieve maximum productivity and cost-effectiveness.',
        },
      },
    },

    es: {
      navbar: {
        home: 'Inicio',
        services: 'Servicios',
        products: 'Productos',
        aboutUs: 'Nosotros',
        ourWork: 'Nuestro trabajo',
        contactUs: 'Contáctanos',
      },
      footer: {
        moreInfo: 'MÁS INFORMACIÓN',
        infoDescription:'Cuéntanos tus ideas de soluciones digitales para empresas e industrias y te ayudamos a hacerlas realidad.',
        findUs: 'Encuéntranos en: Cra. 49c #75 - 47',
        contact: 'CONTACTO',
        followUs: 'SÍGUENOS',
      },
      services: {
        softwareDevelopment: 'Desarrollo de Software',
        softwareDevelopmentDesc:'Creamos soluciones de software escalables, eficientes e innovadoras adaptadas a las necesidades de tu negocio. Desde aplicaciones personalizadas hasta integraciones de sistemas, nuestro equipo asegura una funcionalidad sin interrupciones y un rendimiento robusto para elevar tus operaciones.',
        userExperience: 'Experiencia de Usuario (UX)',
        userExperienceDesc:'Ofrecemos experiencias digitales excepcionales con nuestros servicios de experiencia de usuario. Diseñamos interfaces intuitivas e interacciones sin problemas que priorizan a tus usuarios, asegurando su satisfacción y fomentando el compromiso.',
        powerfulAI: 'Inteligencia Artificial',
        powerfulAIDesc:'Desbloquea todo el potencial de la inteligencia artificial con nuestras soluciones de vanguardia. Desde análisis predictivos hasta automatización, aprovechamos la IA para entregar resultados más inteligentes, rápidos e impactantes para tu negocio.',
        productDesign: 'Diseño de Producto',
        productDesignDesc:'Transforma tus ideas en realidad con nuestros servicios de diseño de productos. Combinamos creatividad y experiencia técnica para desarrollar soluciones centradas en el usuario que sean funcionales, visualmente atractivas y perfectamente alineadas con los objetivos de tu negocio.',
        hardwareIntegrator: 'Integrador de Hardware',
        hardwareIntegratorDesc:'Conecta y optimiza tus sistemas sin problemas con nuestros servicios de integración de hardware. Nos especializamos en integrar dispositivos y tecnologías avanzadas para crear sistemas unificados que mejoren la productividad y la eficiencia operativa.',
        itConsulting: 'Consultoría de TI',
        itConsultingDesc:'Empodera tu negocio con una consultoría estratégica de TI que impulse la transformación digital. Proporcionamos orientación experta para alinear tus inversiones tecnológicas con tus objetivos, mejorando tu infraestructura y logrando el éxito a largo plazo.',
      },
      pricing: {
        plans: {
          basic: {
            title: 'F-Basic',
            price: '50 USD',
            trial: '14 días de prueba gratuita',
            button: 'Elige este plan',
            includes: 'El plan F-Basic incluye:',
            features: {
              moduleAccess: 'Acceso a 2 módulos de gestión.',
              adminPanel: 'Acceso a panel administrativo.',
              notifications: 'Sin notificaciones ni mantenimientos.',
              reports: 'Sin reportes ni análisis inteligente.',
            },
          },
          pro: {
            title: 'F-Pro',
            price: '150 USD',
            trial: '30 días de prueba gratuita',
            button: 'Elige este plan',
            includes: 'El plan F-Pro incluye:',
            features: {
              moduleAccess: 'Acceso a todos los módulos de gestión.',
              adminPanel: 'Acceso a panel administrativo.',
              notifications: 'Notificaciones y mantenimientos.',
              reports: 'Reportes y análisis inteligente.',
            },
          },
          enterprise: {
            title: 'F-Enterprise',
            price: '400 USD',
            trial: '7 días de prueba gratuita',
            button: 'Elige este plan',
            includes: 'El plan F-Enterprise incluye:',
            features: {
              moduleAccess: 'Acceso a todos los módulos de gestión.',
              adminPanel: 'Acceso a panel administrativo.',
              notifications: 'Notificaciones y mantenimientos.',
              reports: 'Reportes y análisis inteligente.',
            },
          },
        },
      },
      usecasedescription:'Ftrack es una plataforma de monitoreo de activos versátil, adecuada para una amplia gama de sectores. Permite a las empresas de diferentes industrias, desde logística hasta manufactura, gestionar y supervisar sus activos en tiempo real, optimizando la operación y reduciendo costos con alertas inteligentes y una interfaz personalizable.',
      pricingdescription:'Ftrack ofrece planes flexibles para adaptarse a las necesidades de diferentes tipos de negocios. Desde el plan básico para empresas que inician su camino en el monitoreo de activos, hasta opciones avanzadas con características completas para organizaciones más grandes. Cada plan incluye una prueba gratuita para que puedas experimentar todas las ventajas antes de tomar una decisión. Descubre el plan ideal para ti y optimiza la gestión de tus activos hoy mismo.',
      title: '¿Qué ofrece ftrack?',
      realtime: 'Tiempo real',
      realtimeDescription:'Visualiza todos tus activos en un mapa interactivo y mantente informado con actualizaciones al segundo. Mantente al tanto de la ubicación y estado de tus activos.',
      smartAlerts: 'Alertas inteligentes',
      smartAlertsDescription:'Recibe notificaciones y alertas predictivas inmediatas ante cualquier eventualidad.',
      whiteLabelPlatform: 'Plataforma Marca Blanca',
      whiteLabelDescription: 'Personaliza tu experiencia con tus logos y colores propios.',
      assetManagement: 'Administración de activos',
      assetManagementDescription:'Organiza y categoriza todos tus activos en un solo lugar Monitoreo y control.',
      iotIntegrations: 'Integraciones IoT',
      iotIntegrationsDescription: 'Conecta dispositivos inteligentes para un monitoreo completo.',
      maintenanceManagement: 'Gestión de mantenimientos',
      maintenanceDescription:'Almacena el historial de mantenimiento y documentación de tus activos.',
      casesOfUse: 'Casos de uso',
      pricingg: 'Precios',
      basicPlan: 'F-Basic',
      basicPlanDescription: 'Incluye 2 módulos de gestión, acceso a panel administrativo.',
      proPlan: 'F-Pro',
      proPlanDescription:'Incluye todos los módulos de gestión, acceso a panel administrativo y alertas predictivas.',
      enterprisePlan: 'F-Enterprise',
      enterprisePlanDescription:'Incluye todos los módulos de gestión, acceso a panel administrativo, alertas predictivas y análisis inteligente.',
      freeTrial: '14 días de prueba gratuita',
      freeTrialPro: '30 días de prueba gratuita',
      freeTrialEnterprise: '7 días de prueba gratuita',
      choosePlan: 'Elegir este plan',
      requestDemo: 'Solicita tu demo gratis',
      about: {
        title: 'Sobre nosotros',
        bigText: 'Somos un equipo de profesionales',
        description:'En FOURIN S.A.S, nos dedicamos a empoderar negocios mediante tecnología de punta y soluciones personalizadas. Con sede en Colombia, nuestro equipo combina experiencia en desarrollo de software, diseño de productos, integración de hardware, consultoría de TI e inteligencia artificial para ofrecer resultados innovadores e impactantes.',
      },
      stats: {
        projectsCompleted: {
          bigText: '5+',
          subtitle: 'Proyectos completados',
          description:
            'Proyectos llenos de experiencias y conocimientos nos forman como compañía en FOURIN S.A.S.',
        },
        satisfaction: {
          bigText: '96%',
          subtitle: 'De satisfacción',
          description:
            'La satisfacción de nuestros clientes refleja la calidad constante que brindamos.',
        },
        recommendations: {
          bigText: '9/10',
          subtitle: 'Recomendaciones',
          description:
            'Las métricas demuestran que la comercialización en línea genera beneficios a largo plazo.',
        },
      },
      goals: {
        title: 'Nuestra misión',
        description:
          'Es transformar ideas en realidad mediante la integración fluida de tecnología en tus procesos. Creemos en simplificar la complejidad y optimizar operaciones, asegurando que cada solución esté alineada con tus objetivos y desafíos únicos.',
        description2:
          'Con un fuerte enfoque en la experiencia del usuario y una pasión por la innovación, ayudamos a nuestros clientes a alcanzar su máximo potencial, ya sea automatizando flujos de trabajo, diseñando productos intuitivos o implementando estrategias impulsadas por inteligencia artificial. Nuestro enfoque es colaborativo, centrado en el cliente y orientado a resultados.',
        description3:
          'En FOURIN, no solo resolvemos problemas: estamos moldeando el futuro de la tecnología. Construyámoslo juntos.',
      },
      approach: {
        title: 'Nuestro enfoque',
        innovation: 'Innovación en el núcleo: Integramos los últimos avances en tecnología y AI.',
        customer: 'Soluciones centradas en el cliente: Tus necesidades guían todo lo que hacemos.',
        integration:
          'Integración fluida: Desde software hasta hardware, creamos sistemas unificados.',
        growth: 'Fomentamos el crecimiento: Nuestras soluciones impulsan eficiencia y éxito.',
      },

      know: {
        title:
          'Conócenos: un equipo apasionado de innovadores dedicados a superar desafíos y generar impacto.',
        become:
          'Para convertirnos en la empresa que los clientes desean, se necesita un grupo de personas apasionadas.',
        knowtext:
          'En Fourin, brindamos soluciones innovadoras y personalizadas diseñadas para satisfacer tus necesidades únicas. Nos destacamos por nuestra atención al detalle, soporte excepcional y dedicación al éxito de tus proyectos. Elige calidad, experiencia y resultados garantizados. ¡Somos tu mejor opción!',
        transform:
          '¿Listo para transformar tu negocio con tecnología? ¡Contáctanos y hagámoslo realidad!',
      },
      home: {
        banner: {
          title: 'Haz crecer la innovación a través de tecnología y AI',
          description:
            'Desata las posibilidades del futuro con Fourin. Experimenta el máximo potencial de la tecnología a través de nuestras soluciones personalizadas diseñadas para impulsar tu negocio.',
          button: 'Contactanos',
        },
        expertise: {
          title: 'Nuestros servicios',
          subtitle: 'Para todas tus necesidades tecnológicas.',
          button: 'Más información',
        },
        projects: {
          title: 'Productos',
          monitorTitle: 'Monitorea tus activos en tiempo real',
          monitorDescription:'Ftrack es tu socio ideal en la gestión de activos, ofreciendo soluciones inteligentes que redefinen cómo las empresas rastrean, monitorean y optimizan sus recursos. Con tecnología de vanguardia y un enfoque centrado en el usuario, Ftrack simplifica procesos complejos, proporciona ideas accionables y asegura que cada activo ofrezca su máximo valor.',
          discoverButton: 'Descubrir',
        },
        sponsors: {
          title: 'Nos apoyan',
          description:
            'Mejora la eficiencia y optimiza las operaciones con nuestras soluciones impulsadas por inteligencia artificial. Optimiza tus procesos empresariales para lograr la máxima productividad y rentabilidad.',
        },
      },
      contact: {
        modal: {
          confirmation: {
            title: '¿Estás seguro de que quieres enviar la solicitud?',

            message: 'Una vez que envíes la solicitud, no podrás editar la información.',
          },
          success: {
            title: '¡Correo enviado exitosamente!',
            message: 'Gracias por contactarnos. Nos pondremos en contacto contigo pronto.',
          },
        },

        header: {
          title: 'Nos encantaría ayudarte',
          description:
            '¿Tienes preguntas, inquietudes o una idea que quieras compartir? Nuestro equipo está aquí para escucharte y encontrar soluciones que se ajusten a tus necesidades.',
        },
        form: {
          firstName: {
            label: 'Nombre',
            placeholder: 'Nombre',
          },
          lastName: {
            label: 'Apellido',
            placeholder: 'Apellido',
          },
          companyName: {
            label: 'Nombre de la empresa (opcional)',
            placeholder: 'Fourin SAS',
          },
          email: {
            label: 'Correo electrónico',
            placeholder: 'email',
          },
          phone: {
            label: 'Número de teléfono',
            placeholder: 'Ingresa tu número de teléfono',
          },
          message: {
            label: 'Mensaje',
            placeholder: 'Déjanos un mensaje aquí...',
          },
          button: 'Enviar mensaje',
        },
      },
    },
  },
})

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n) // Usar la instancia configurada de i18n

app.mount('#app')
